import { useRef } from 'react';
import { Card, Divider, Form, Tabs, Title } from '@bancobarigui/barihaus';

import { ProviderForm } from './ProviderForm';
import { AddressFormItem, AddressFormRef } from '@/components/AddressForm';
import { ValueRangeItem } from '@/components/ValueRangeItem';
import { SwitchCardItem } from '@/components/SwitchCardItem';
import { RegisterFormButtons } from '@/components/RegisterFormButtons';
import { PropertyTypesTransfer } from '@/components/PropertyTypesTransfer';
import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { LoadingOverlay } from '@/components/LoadingOverlay';
import { InspectionTypesTransfer } from '@/components/InspectionTypesTransfer';
import { ServiceCheck, FeatureAlert } from '@/shared/components';

import { useProviderRegister } from './useProviderRegister';

function ProviderRegisterContent() {
  const [form] = Form.useForm();
  const addressFormRef = useRef<AddressFormRef>(null);

  const { onSubmit, isSubmitting } = useProviderRegister({ addressFormRef });

  return (
    <>
      <LoadingOverlay visible={isSubmitting} tip="Cadastrando prestadora..." />

      <Form form={form} name="basic" onFinish={onSubmit} className="space-y-8">
        <Card>
          <ProviderForm />
        </Card>

        <Title level={5}>Endereço da Prestadora</Title>

        <AddressFormItem ref={addressFormRef} form={form} />

        <Divider>Configuracões</Divider>

        <SwitchCardItem
          title="Permitir recebimento de demandas"
          name="allowsDemandReceiving"
          text="Ao habilitar esta opção, a prestadora ficará habilitada a receber novos
                direcionamentos"
        />

        <Tabs
          items={[
            {
              key: '1',
              label: 'Tipos de Inspeção',
              children: <InspectionTypesTransfer />,
            },

            {
              key: '2',
              label: 'Tipos de Imovel',
              children: <PropertyTypesTransfer />,
            },

            {
              key: '3',
              label: 'Valor',
              children: <ValueRangeItem />,
            },
          ]}
        />

        <RegisterFormButtons onClickCancel={() => {}} loading={isSubmitting} />
      </Form>
    </>
  );
}

export default function ProviderRegister() {
  return (
    <ProtectedRouteContainer
      pageHeader={<PageHeader title="Cadastrar Nova Prestadora" />}
    >
      <FeatureAlert services={['registration']} />
      <ServiceCheck
        services={['registration']}
        featureName="Cadastro de Prestadora"
      >
        <ProviderRegisterContent />
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}
